module.exports = {
	"languages": [
		{
			"name": "English",
			"key": "en",
			"flag": "lang_en_icon_0094bb_132"
		},
		{
			"name": "Hindi",
			"key": "hi",
			"flag": "lang_hi_icon_0094bb_132"
		},
		{
			"name": "Tamil",
			"key": "ta",
			"flag": "lang_ta_icon_0094bb_132"
		}
	]
};


//////////////////
// WEBPACK FOOTER
// ./src/app/config/languages.json
// module id = 484
// module chunks = 0